var _ellipse, _path, _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeu3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.3438,
    cy: 70.797,
    rx: 41.3438,
    ry: 22.797,
    fill: "#52537A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.6215 105.555C62.9183 99.2665 68.9529 80.0522 69.933 71.2311L61.3375 70.9542C66.7544 79.308 53.7839 97.5021 46.6215 105.555Z",
    fill: "#52537A"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 69.6385,
    y1: 78.5819,
    x2: 87.0611,
    y2: 61.1594,
    stroke: "#E08A8A",
    strokeWidth: 4.97223
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 69.8361,
    y1: 61.16,
    x2: 86.4102,
    y2: 77.7341,
    stroke: "#E08A8A",
    strokeWidth: 4.97223
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeu3);
export default __webpack_public_path__ + "static/media/neu-3.2d6cbb5288e44146439d927ac5f03867.svg";
export { ForwardRef as ReactComponent };